package com.svdsak.components.sections

import androidx.compose.runtime.*
import com.svdsak.style.slideDown
import com.svdsak.style.slideRight
import com.svdsak.style.slideUp
import com.svdsak.style.zoomIn
import com.varabyte.kobweb.compose.css.AnimationIterationCount
import com.varabyte.kobweb.compose.css.BoxShadow
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.foundation.layout.Arrangement
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Row
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.navigation.OpenLinkStrategy
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.icons.fa.*
import com.varabyte.kobweb.silk.components.layout.SimpleGrid
import com.varabyte.kobweb.silk.components.layout.numColumns
import com.varabyte.kobweb.silk.components.navigation.Link
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.style.animation.toAnimation
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import kotlinx.coroutines.delay
import org.jetbrains.compose.web.css.*

@Composable
fun LandingComponent(
    breakpoint: Breakpoint,
    modifier: Modifier = Modifier
) {
    var imageSrc by remember { mutableStateOf("logo") }
    val imageList = listOf("logo", "varada", "gurugalu", "ashwatha")
    var index by remember { mutableIntStateOf(0) }
    LaunchedEffect(true, imageSrc) {
        delay(5000L)
        if (index < imageList.size - 1) {
            index++
            imageSrc = imageList[index]

        } else {
            index = 0
            imageSrc = imageList[index]
        }

        println("Index is $index $imageSrc")

    }
    SimpleGrid(
        numColumns = numColumns(base = 1, lg = 2),
        modifier = modifier
            .height(100.vh)
            .position(Position.Relative)
            .overflow(Overflow.Hidden)
            .margin(1.cssRem)
    ) {
        if (breakpoint < Breakpoint.LG) {
            ImageCol(imageSrc, breakpoint, modifier)
            when (index) {
                0 -> DetailCol(breakpoint, modifier)
                1 -> VaradaDetail(breakpoint, modifier)
                2 -> GuruDetail(breakpoint, modifier)
                3 -> AshwathaDetail(breakpoint, modifier)
            }

        } else {
            when (index) {
                0 -> DetailCol(breakpoint, modifier)
                1 -> VaradaDetail(breakpoint, modifier)
                2 -> GuruDetail(breakpoint, modifier)
                3 -> AshwathaDetail(breakpoint, modifier)
            }
            ImageCol(imageSrc, breakpoint, modifier)
        }


    }

}

@Composable
fun VaradaDetail(
    breakpoint: Breakpoint,
    modifier: Modifier
) {
    Column(
        modifier = if (breakpoint > Breakpoint.SM) modifier.fillMaxSize() else Modifier.height(50.vh),
        verticalArrangement = Arrangement.Center
    ) {
        Row(Modifier.flexWrap(FlexWrap.Wrap).fillMaxWidth()) {
            SpanText(
                text = "Our Inspiration, ",
                modifier = modifier
                    .color(Colors.GoldenRod)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 4.cssRem else 2.cssRem)
                    .textShadow(
                        0.cssRem, 0.cssRem, if (breakpoint > Breakpoint.SM) 0.2.cssRem else 0.1.cssRem, Colors.DarkBlue
                    )
                    .animation(
                        slideDown.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
            SpanText(
                text = "Shri Varadavithala Dasaru ",
                modifier = modifier
                    .color(Colors.Wheat)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 4.cssRem else 2.cssRem)
                    .textShadow(
                        0.2.cssRem, 0.1.cssRem, 0.2.cssRem, Colors.RebeccaPurple
                    ).animation(
                        slideRight.toAnimation(
                            duration = 1.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
        }
    }
}

@Composable
fun AshwathaDetail(
    breakpoint: Breakpoint,
    modifier: Modifier
) {
    Column(
        modifier = if (breakpoint > Breakpoint.SM) modifier.fillMaxSize() else Modifier.height(50.vh),
        verticalArrangement = Arrangement.Center
    ) {
        Row(Modifier.flexWrap(FlexWrap.Wrap).fillMaxWidth()) {
            SpanText(
                text = "With Blessings, ",
                modifier = modifier
                    .color(Colors.GoldenRod)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 4.cssRem else 2.cssRem)
                    .textShadow(
                        0.cssRem, 0.cssRem, if (breakpoint > Breakpoint.SM) 0.2.cssRem else 0.1.cssRem, Colors.DarkBlue
                    )
                    .animation(
                        slideDown.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
            SpanText(
                text = "Shri Aswatharayaru ",
                modifier = modifier
                    .color(Colors.Wheat)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 4.cssRem else 2.cssRem)
                    .textShadow(
                        0.2.cssRem, 0.1.cssRem, 0.2.cssRem, Colors.RebeccaPurple
                    ).animation(
                        slideRight.toAnimation(
                            duration = 1.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
            SpanText(
                text = " (1926 - 2021)",
                modifier = modifier
                    .margin(top = if (breakpoint > Breakpoint.SM) 1.5.cssRem else 0.7.cssRem)
                    .color(Colors.PaleGoldenRod)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 1.5.cssRem else 0.8.cssRem)
                    .textShadow(
                        0.05.cssRem, 0.05.cssRem, 0.05.cssRem, Colors.RebeccaPurple
                    )
                    .animation(
                        slideRight.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
        }
    }
}

@Composable
fun GuruDetail(
    breakpoint: Breakpoint,
    modifier: Modifier
) {
    Column(
        modifier = if (breakpoint > Breakpoint.SM) modifier.fillMaxSize() else Modifier.height(50.vh),
        verticalArrangement = Arrangement.Center
    ) {
        Row(Modifier.flexWrap(FlexWrap.Wrap).fillMaxWidth()) {
            SpanText(
                text = "Our Guru, ",
                modifier = modifier
                    .color(Colors.GoldenRod)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 4.cssRem else 2.cssRem)
                    .textShadow(
                        0.cssRem, 0.cssRem, if (breakpoint > Breakpoint.SM) 0.2.cssRem else 0.1.cssRem, Colors.DarkBlue
                    )
                    .animation(
                        slideDown.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
            SpanText(
                text = "Shri Gurujagannathavithala Dasaru ",
                modifier = modifier
                    .color(Colors.Wheat)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 4.cssRem else 2.cssRem)
                    .textShadow(
                        0.2.cssRem, 0.1.cssRem, 0.2.cssRem, Colors.RebeccaPurple
                    ).animation(
                        slideRight.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
            SpanText(
                text = "",
                modifier = modifier
                    .margin(top = if (breakpoint > Breakpoint.SM) 1.5.cssRem else 0.7.cssRem)
                    .color(Colors.PaleGoldenRod)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 1.5.cssRem else 0.8.cssRem)
                    .textShadow(
                        0.05.cssRem, 0.05.cssRem, 0.05.cssRem, Colors.RebeccaPurple
                    )
                    .animation(
                        slideRight.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
        }
    }
}

@Composable
private fun DetailCol(
    breakpoint: Breakpoint,
    modifier: Modifier
) {
    Column(
        modifier = if (breakpoint > Breakpoint.SM) modifier.fillMaxSize() else Modifier.height(50.vh),
        verticalArrangement = Arrangement.Center
    ) {
        Row(Modifier.flexWrap(FlexWrap.Wrap).fillMaxWidth()) {
            SpanText(
                text = "Namaste, ",
                modifier = modifier
                    .color(Colors.GoldenRod)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 4.cssRem else 2.cssRem)
                    .textShadow(
                        0.cssRem, 0.cssRem, if (breakpoint > Breakpoint.SM) 0.2.cssRem else 0.1.cssRem, Colors.DarkBlue
                    )
                    .animation(
                        slideDown.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
            SpanText(
                text = "We're ",
                modifier = modifier
                    .color(Colors.White)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 4.cssRem else 2.cssRem)
                    .textShadow(
                        0.cssRem,
                        0.cssRem,
                        if (breakpoint > Breakpoint.SM) 0.2.cssRem else 0.1.cssRem,
                        Colors.Aquamarine
                    )
                    .animation(
                        slideDown.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
            SpanText(
                text = "Coming Soon ",
                modifier = modifier
                    .color(Colors.Wheat)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 6.cssRem else 2.5.cssRem)
                    .textShadow(
                        0.2.cssRem, 0.1.cssRem, 0.2.cssRem, Colors.RebeccaPurple
                    ).animation(
                        zoomIn.toAnimation(
                            duration = 3.s,
                            timingFunction = AnimationTimingFunction.EaseInOut,
                            direction = AnimationDirection.Alternate,
                            iterationCount = AnimationIterationCount.Infinite
                        )
                    )
            )
            SpanText(
                text = "Shri Varadavithala Dasa Sahitya Adhyayana Kendra",
                modifier = modifier
                    .margin(top = if (breakpoint > Breakpoint.SM) 1.cssRem else 0.5.cssRem)
                    .color(Colors.White)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 2.cssRem else 1.cssRem)
                    .textShadow(
                        0.1.cssRem,
                        0.cssRem,
                        if (breakpoint > Breakpoint.SM) 0.2.cssRem else 0.05.cssRem,
                        Colors.GoldenRod
                    ).animation(
                        slideUp.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
            SpanText(
                text = "Empower & En-Vision the Life through a literature of Karnataka Hari Dasa's",
                modifier = modifier
                    .margin(top = if (breakpoint > Breakpoint.SM) 1.5.cssRem else 0.7.cssRem)
                    .color(Colors.PaleGoldenRod)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 1.5.cssRem else 0.8.cssRem)
                    .textShadow(
                        0.05.cssRem, 0.05.cssRem, 0.05.cssRem, Colors.RebeccaPurple
                    )
                    .animation(
                        slideRight.toAnimation(
                            duration = 2.s,
                            timingFunction = AnimationTimingFunction.EaseIn,
                            direction = AnimationDirection.Normal,
                            fillMode = AnimationFillMode.Both
                        )
                    )
            )
            SpanText(
                text = "Follow Us ",
                modifier = modifier
                    .margin(top = if (breakpoint > Breakpoint.SM) 1.5.cssRem else 0.7.cssRem)
                    .color(Colors.Wheat)
                    .fontWeight(FontWeight.ExtraBold)
                    .fontSize(if (breakpoint > Breakpoint.SM) 3.cssRem else 1.5.cssRem)
                    .textShadow(
                        0.2.cssRem, 0.1.cssRem, 0.2.cssRem, Colors.RebeccaPurple
                    ).animation(
                        zoomIn.toAnimation(
                            duration = 3.s,
                            timingFunction = AnimationTimingFunction.EaseInOut,
                            direction = AnimationDirection.Alternate,
                            iterationCount = AnimationIterationCount.Infinite
                        )
                    )
            )
        }
        LinkRow()
    }
}

@Composable
private fun LinkRow() {
    Row(
        Modifier.fillMaxWidth().margin(top = 1.cssRem),
        horizontalArrangement = Arrangement.spacedBy(1.cssRem)
    ) {
        Link(
            "https://www.facebook.com/varadavithalaru/",
            openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
        ) {
            FaFacebook(size = IconSize.X3, modifier = Modifier.color(Color("#316FF6")))
        }
        Link(
            "https://www.instagram.com/varadadasa/",
            openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
        ) {
            FaInstagram(modifier = Modifier.color(Color("#E1306C")), size = IconSize.X3)
        }
        Link(
            "https://www.x.com/varadadasa/",
            openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
        ) {
            FaTwitter(modifier = Modifier.color(Colors.SkyBlue), size = IconSize.X3)
        }
        Link(
            "https://whatsapp.com/channel/0029VanRdRcFMqraEBnM7G0R/204",
            openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
        ) {
            FaWhatsapp(modifier = Modifier.color(Colors.LightGreen), size = IconSize.X3)
        }
        Link(
            "https://www.youtube.com/@shrivaradauvacha",
            openExternalLinksStrategy = OpenLinkStrategy.IN_NEW_TAB
        ) {
            FaYoutube(modifier = Modifier.color(Color("#FF0000")), size = IconSize.X3)
        }
    }
}

@Composable
private fun ImageCol(
    imageSrc: String = "logo",
    breakpoint: Breakpoint,
    modifier: Modifier,
) {
    Column(
        modifier = if (breakpoint > Breakpoint.SM) modifier.fillMaxSize() else Modifier.height(50.vh),
        horizontalAlignment = Alignment.CenterHorizontally,
        verticalArrangement = Arrangement.Center
    ) {
        Image(
            src = "${imageSrc}.webp",
            alt = imageSrc.split(".")[0],
            modifier = modifier
                .width(if (breakpoint > Breakpoint.SM) 40.vw else 70.vw)
                .animation(
                    zoomIn.toAnimation(
                        duration = 4.s,
                        timingFunction = AnimationTimingFunction.EaseInOut,
                        direction = AnimationDirection.Alternate,
                        iterationCount = AnimationIterationCount.Infinite
                    )
                ).border {
                    width(if (breakpoint > Breakpoint.SM) 0.2.cssRem else 0.05.cssRem)
                    style(
                        LineStyle("solid")
                    )
                    color(Colors.AntiqueWhite)
                }
                .boxShadow(
                    BoxShadow.of(0.cssRem, 0.cssRem, 1.cssRem, 0.5.cssRem, Colors.AntiqueWhite, false)
                )
                .borderRadius(50.percent)
                .boxShadow()
                .alignContent(AlignContent.Center)

        )
    }
}